import { Check } from "lucide-react";

import { cn } from "@/infrastructure/lib/utils";

interface SkillInstallerProgressProps {
  /**
   * Só `id` e `label`, e não o `SkillInstallerStep` da instalação: a mesma
   * régua serve à publicação, cujos passos (pacote, catálogo) não pertencem ao
   * vocabulário de quem instala. Aqui o `id` é apenas a chave da lista.
   */
  steps: Array<{ id: string; label: string }>;
  currentStep: number;
}

/**
 * Onde a pessoa está na sequência (AC12).
 *
 * Os passos vêm prontos de quem chama, já filtrados: um passo que não tem
 * conteúdo não aparece aqui nem é contado, senão o indicador prometeria uma
 * etapa que a pessoa nunca vai ver.
 */
export const SkillInstallerProgress = ({ steps, currentStep }: SkillInstallerProgressProps) => (
  <div className="border-b px-6 py-4">
    <ol className="flex items-center gap-2">
      {steps.map((step, index) => {
        const done = index < currentStep;
        const active = index === currentStep;

        return (
          <li key={step.id} className="flex flex-1 items-center gap-2 last:flex-none">
            <div className="flex items-center gap-2">
              <span
                className={cn(
                  "flex h-7 w-7 shrink-0 items-center justify-center rounded-full border text-xs font-medium transition-colors",
                  done && "border-primary bg-primary text-primary-foreground",
                  active && "border-primary text-primary",
                  !done && !active && "border-border text-muted-foreground"
                )}
              >
                {done ? <Check className="h-3.5 w-3.5" /> : index + 1}
              </span>

              {/* O rótulo só do passo corrente, para a régua caber em telas
                  estreitas sem quebrar a linha. */}
              <span
                className={cn(
                  "hidden text-sm sm:inline",
                  active ? "font-medium text-foreground" : "text-muted-foreground"
                )}
              >
                {step.label}
              </span>
            </div>

            {index < steps.length - 1 && (
              <span
                className={cn("h-px flex-1 transition-colors", done ? "bg-primary" : "bg-border")}
              />
            )}
          </li>
        );
      })}
    </ol>
  </div>
);
